export default __webpack_public_path__ + "nav-side-btn-next.png?74f8d15fa32a13f20f451d0399194e70";